import { Base } from 'layouts'
import { ProfileForm } from 'components'

import * as S from './styled'

export function Profile() {
  return (
    <Base>
      <S.GridContainer container>
        <ProfileForm />
      </S.GridContainer>
    </Base>
  )
}
